import { useEffect } from 'react'

export default function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to)
  }, [to])

  return (
    <div className="min-h-screen flex items-center justify-center bg-noir-primary">
      <p className="text-sm text-text-secondary">
        Redirecting to <a href={to} className="text-accent-cyan hover:underline">{to}</a>...
      </p>
    </div>
  )
}
